import PropTypes from 'prop-types';
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import Col from 'ravenjs/lib/Col';
import FaIcon from 'ravenjs/lib/FaIcon';
import List from 'ravenjs/lib/List';
import ListItem from 'ravenjs/lib/ListItem';
import Row from 'ravenjs/lib/Row';
import Typography from 'ravenjs/lib/Typography';
import { callFunc } from 'ravenjs/utils/actions';

function SelectedListFilters(props) {
    const { onRemove, parentId, selected } = props;

    if (_isEmpty(selected)) {
        return null;
    }

    return (
        <List backgroundColor="transparent" flush>
            {selected.map(filter => {
                const { id, label } = filter;

                function onClick() {
                    return callFunc(onRemove, { parentId, id });
                }

                return (
                    <ListItem key={id} padding="5px 0">
                        <Row gutter={false} alignItems="baseline">
                            <Col gutter={false} size="auto">
                                <Typography
                                    gutterBottom="0"
                                    gutterRight="5px"
                                    onClick={onClick}
                                    type="link"
                                >
                                    <FaIcon height="15px" icon={faTimes} width="15px" margin="0" />
                                </Typography>
                            </Col>
                            <Col gutter={false}>
                                <Typography gutterBottom="0" gutterTop="0" as="span">
                                    {label}
                                </Typography>
                            </Col>
                        </Row>
                    </ListItem>
                );
            })}
        </List>
    );
}

SelectedListFilters.propTypes = {
    onRemove: PropTypes.func,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selected: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
        })
    ),
};

SelectedListFilters.defaultProps = {
    onRemove: null,
    parentId: null,
    selected: null,
};

export default SelectedListFilters;
